<template>
  <!-- 夜审信息弹框 -->
  <QzDialog
    :title="$t('componentsNightaudit.nightTrialInProgress')"
    :append-to-body="true"
    :visible.sync="infoVisible"
    :before-close="beforeClose"
    :noCancel="true"
    :confirm-text="$t('common.close')"
    @closed="closed"
    @confirm="closeAuditDialog"
    width="592px"
  >
    <div class="scroller-section">
      <p class="sub-text">
        {{ $t('componentsNightaudit.theCurrentBusinessDayIs') }}{{ businessDay }}
      </p>
      <p class="title-text title">{{ $t('componentsNightaudit.startTheNightTrial') }}</p>
      <template v-for="item of auditLogList">
        <p class="sub-text" :key="item.nightTrialStep">{{ item.nightTrialStepName }}</p>
        <template v-for="(contentItem, contentItemIndex) of item.detailRecordDtos">
          <p
            class="title-text"
            :key="contentItem.num"
            :class="{
              error: !item.stepResult && contentItemIndex === item.detailRecordDtos.length - 1,
              single: contentItem.num < 10,
            }"
          >
            {{ contentItem.msg }}
          </p>
        </template>
      </template>
    </div>
    <p class="processing-tip" :class="[auditStatusTipColor[auditStatus]]">
      <template v-if="auditStatus === 'pending'"
        ><img class="i-tip" src="@/assets/icon-pay-unusual.png" />{{
          $t('componentsNightaudit.theNightTrialIsInProgressAndCannotBeClosed')
        }}</template
      >
      <template v-else-if="auditStatus === 'reject'"
        ><img class="i-tip" src="@/assets/night-audit-error.png" />{{
          $t(
            'componentsNightaudit.nightAuditFailedPleaseHandleAccordingToThePromptAndPerformTheNightAuditAgainIfYouEncounterAnyProblemsPleaseContactTechnicalSupport'
          )
        }}。<router-link to="/help/feedback" target="_blank" class="feed"
          >{{ $t('componentsNightaudit.immediateFeedback') }}
          <img class="icon-toggle" src="@/assets/icon-toggle.png" alt="" /></router-link
      ></template>
      <template v-else-if="auditStatus === 'success'"
        ><img class="i-tip" src="@/assets/night-audit-success.png" />{{
          $t('componentsNightaudit.nightAuditCompleted')
        }}</template
      >
    </p>
  </QzDialog>
</template>
<script>
import { deepClone, helpJsonParse } from '@/utils/index';
let element = null;
export default {
  name: 'NightAudit',
  data() {
    return {
      isHandChange: false,
      infoVisible: false,
      auditLogList: [],
      auditStatus: 'pending',
      auditStatusTipColor: {
        pending: '',
        reject: 'error',
        success: 'success',
      },
    };
  },
  computed: {
    overCheck() {
      return this.auditStatus !== 'pending';
    },
    businessDay() {
      return this.$store.getters.businessDay;
    },
  },
  watch: {
    '$store.getters.socketMessage'(resData) {
      const { type, childrenType, context = '' } = resData;
      if (type === 'socket' && childrenType === 'nightTrial') {
        const resContext = helpJsonParse(context);
        console.log(this.$t('componentsNightaudit.nightTrialNewsNotice2'), resContext);
        if (!this.infoVisible) {
          this.$store.commit('user/SET_NIGHT_AUDIT_STATUS', {
            data: 'show',
            isSetLocalStorage: true,
          });
          this.infoVisible = true;
        }
        const {
          content,
          nightTrialStep,
          exitNightTrial,
          stepResult,
          detailRecordDtos,
        } = resContext;
        if (nightTrialStep.endsWith('1')) {
          this.auditLogList = [];
        }
        if (!stepResult) {
          //如果此步骤失败的话，移除最后一句提示性消息
          detailRecordDtos.splice(detailRecordDtos.length - 1, 1);
        }
        this.auditLogList.push(resContext);
        this.$nextTick(() => {
          this.scrollToBottom();
        });
        if (exitNightTrial) {
          // 如果此步骤退出夜审
          if (!nightTrialStep.endsWith('5') || !stepResult) {
            this.auditStatus = 'reject';
          } else {
            this.auditStatus = 'success';
            this.$store.commit('app/SET_REFRESH', true);
          }
        }
      }
    },
    '$store.getters.nightAuditStatus'(value) {
      if (!value) {
        this.infoVisible = false;
      }
    },
    '$store.getters.hotelCode'(value) {
      if (value) {
        this.checkIsNightAuditing().then((res) => {
          this.infoVisible = res;
        });
      }
    },
  },
  methods: {
    scrollToBottom() {
      if (!element) {
        element = window.document.getElementsByClassName('scroller-section')[0];
      }
      element.scrollTo(0, element.clientHeight);
    },
    beforeClose(done) {
      if (this.overCheck) {
        done();
      }
    },
    closed() {
      if (this.auditStatus === 'success' && this.isHandChange) {
        this.$store.commit('user/SET_SHIFTS', {
          data: null,
        });
      }
      this.isHandChange = false;
      this.auditStatus = 'pending';
    },
    closeAuditDialog() {
      if (this.overCheck) {
        this.isHandChange = true;
        this.infoVisible = false;
        this.$store.commit('user/SET_NIGHT_AUDIT_STATUS', {
          data: '',
          isSetLocalStorage: true,
        });
        this.auditLogList = [];
        if (this.auditStatus === 'success') {
          localStorage.removeItem('userShifts');
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.scroller-section {
  counter-reset: index;
  height: 448px;
  overflow-y: scroll;
  background-color: #f4f5f9;
  padding: 16px;
  border-radius: 4px;
  @include scrollBar;
  .sub-text {
    color: #4f5161;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 12px;
    line-height: 1;
    &:nth-of-type(1) ~ .sub-text {
      margin-top: 30px;
    }
  }
  .title-text {
    color: #7b7c89;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.5;
    &:not(.title) {
      padding-left: 26px;
      position: relative;
      margin-top: 6px;
      &.single {
        padding-left: 16px;
      }
      &::before {
        counter-increment: index;
        content: counter(index) '.';
        position: absolute;
        left: 0;
      }
    }
    &.error {
      color: #ff661e;
    }
  }
}
.processing-tip {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #ff8c00;
  font-weight: bold;
  &.error {
    color: #ff661e;
  }
  &.success {
    color: #259bf5;
  }
  font-size: 12px;
  .i-tip {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    vertical-align: middle;
  }
  .feed {
    margin-left: 12px;
    color: #0068b6;
    .icon-toggle {
      vertical-align: middle;
      width: 9px;
      height: 5px;
      transform: rotate(90deg) translateY(3px);
    }
  }
}
</style>
